// @flow
import { Record, Map as ImmutableMap } from 'immutable';
import type { RecordOf, RecordFactory } from 'immutable';

import type { QcsSyncResourceStoreProps } from 'data/qcsSyncResourceTypes';

// ================================================================================================
// Rename Rules STore
// ================================================================================================

type RulesStoreProps = QcsSyncResourceStoreProps & {

};
export type RulesStore = RecordOf<RulesStoreProps>;

export const mkRulesStore: RecordFactory<RulesStoreProps> =
  Record({
    resourcesById: ImmutableMap(),

    lastSyncDate: null,
    loadPending: true,

    isLoading: false,
  });

type RuleProps = {
  id: string,
  clientId: string,
  isDeleted: ?boolean,
  renamePayeeFrom: string,
  renamePayeeTo: string,
  isDoNotRename: ?boolean,
  matchCriteria: string,
};
export type Rule = RecordOf<RuleProps>;

export const mkRule: RecordFactory<RuleProps> =
  Record({
    id: null,
    clientId: null,
    isDeleted: false,
    renamePayeeFrom: '',
    renamePayeeTo: '',
    isDoNotRename: false,
    matchCriteria: 'If Payee Contains',
  });

